import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Loading } from 'react-loading-dot';
import { colors, images } from '~/themes/variables';
import styles from './loadingScreen.style';
const Div = styled.div `
  ${styles}
`;
const LoadingScreen = () => {
    return (_jsxs(Div, { children: [_jsx("img", { src: images.oneroomLogo }), _jsx(Loading, { dots: 5, size: "5px", margin: "8px", background: colors.brandMain })] }));
};
export default LoadingScreen;
